import { SkeletonLoading } from '@saleshandy/design-system';
import React from 'react';
import Table from '../../../../../../../../shared/design-system/components/organisms/table';
import { PaginationShowHide } from '../../../../../../../../shared/design-system/components/organisms/table/types';

const EspToEspFallback: React.FC = () => {
  const columns = [
    {
      dataField: 'testProgress',
      text: 'Test Progress',
      headerLoadingSkeleton: <SkeletonLoading width={60} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={60} height={14} />,
    },
    {
      dataField: 'inboxScore',
      text: 'Inbox Score',
      headerLoadingSkeleton: <SkeletonLoading width={60} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={60} height={14} />,
    },
    {
      dataField: 'inbox',
      text: 'Inbox',
      headerLoadingSkeleton: <SkeletonLoading width={60} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={38} height={14} />,
    },
    {
      dataField: 'spam',
      text: 'Spam',
      headerLoadingSkeleton: <SkeletonLoading width={60} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={38} height={14} />,
    },
    {
      dataField: 'others',
      text: 'Other',
      headerLoadingSkeleton: <SkeletonLoading width={60} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={38} height={14} />,
    },
    {
      dataField: 'notDelivered',
      text: 'Undelivered',
      headerLoadingSkeleton: <SkeletonLoading width={60} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={38} height={14} />,
    },
  ];

  return (
    <div className="esp-placement-report-container-loader w-100">
      <span className="esp-placement-report-header">
        <SkeletonLoading width={185} height={14} />
      </span>
      <div className="esp-placement-report-table-loader w-100">
        <Table
          columns={columns}
          data={[]}
          isLoading={true}
          pagination={PaginationShowHide.HIDE}
          paginationOptions={{
            options: {
              limit: 10,
              page: 1,
              totalElements: 10,
            },
          }}
        />
      </div>
    </div>
  );
};

const TestReportSummaryLoader: React.FC = () => (
  <div className="test-report-summary-container">
    <div className="test-report-summary-header skeleton-header">
      <SkeletonLoading width={185} height={14} />
      <div className="d-flex align-items-center gap-8 test-report-email-sent">
        <SkeletonLoading width={72} height={14} />
        <SkeletonLoading width={192} height={14} />
        <SkeletonLoading width={72} height={14} />
      </div>
    </div>

    <div className="test-report-summary">
      <div className="test-report-summary-content-container">
        <div className="test-report-summary-card-container-wrapper">
          <div className="test-report-summary-card-container">
            <div className="d-flex w-100 justify-content-between">
              <SkeletonLoading width={212} height={14} />
            </div>
            <div className="test-report-summary-cards">
              <div className="test-report-summary-card skeleton-loading">
                <SkeletonLoading width={64} height={14} />
                <SkeletonLoading width={114} height={14} />
              </div>
              <div className="test-report-summary-card skeleton-loading">
                <SkeletonLoading width={64} height={14} />
                <SkeletonLoading width={114} height={14} />
              </div>
              <div className="test-report-summary-card skeleton-loading">
                <SkeletonLoading width={64} height={14} />
                <SkeletonLoading width={114} height={14} />
              </div>
              <div className="test-report-summary-card skeleton-loading">
                <SkeletonLoading width={64} height={14} />
                <SkeletonLoading width={114} height={14} />
              </div>
            </div>
          </div>
        </div>
        <EspToEspFallback />
      </div>
    </div>
  </div>
);

export default TestReportSummaryLoader;
